





























import Fieldset from '~/components/car/classifieds/form/fieldsets/handlers/Fieldset.vue'
import BaseFieldsetMixin from '~/components/car/classifieds/form/fieldsets/handlers/BaseFieldsetMixin.vue'
import {
  computed,
  defineComponent,
  nextTick,
  ref,
  toRefs
} from '@nuxtjs/composition-api'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import CYesOrNoButtonGroup from '~/components/shared/configurable/form/checkbox/CYesOrNoButtonGroup.vue'
import { useI18n } from '~/compositions/i18n'
import { defineComponentTranslations } from '~/utils/i18n'
import {
  CLASSIFIED_FORM_NS,
  FormState
} from '~/store/modules/shared/classifieds/form/state'
import { isObject } from '~/utils/object'
import { SET_FIELD_VALUE } from '~/store/modules/shared/classifieds/form/mutation-types'
import { useAppConfirmationModal } from '~/compositions/app-confirmation-modal'
import { ConfirmationModalOptions } from '~/store/modules/shared/app-confirmation-modal/state'

export default defineComponent({
  components: { CYesOrNoButtonGroup, Fieldset },
  mixins: [BaseFieldsetMixin],
  setup(props) {
    const { fields } = toRefs(props)
    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const { t } = useI18n()
    const userHasPermission = userGetters('hasPermission')

    const { getters, commit } = useNamespacedStore<FormState>(
      CLASSIFIED_FORM_NS
    )
    const getFieldValueByName = getters('getFieldValueByName')
    const confirm = useAppConfirmationModal()

    const isOffertypeLeasing = computed(() => {
      const offerType = getFieldValueByName('offertype')
      return offerType.length && offerType[0] === 'leasing'
    })

    const fieldHasValues = (fieldValue: any) => {
      if (Array.isArray(fieldValue)) {
        return Boolean(fieldValue.length)
      } else if (isObject(fieldValue)) {
        const keys = Object.keys(fieldValue)
        if (keys.length) {
          return keys.some(k => fieldHasValues(fieldValue[k]))
        }
        return false
      }
      return Boolean(fieldValue)
    }
    const fieldsHaveValues = () => {
      return fields.value.some(f => {
        return fieldHasValues(getFieldValueByName(f.name))
      })
    }
    const leasingEnabled = ref(fieldsHaveValues())

    const noLeasingPermission = computed(() => {
      return !userHasPermission('classifieds.leasing')
    })

    const fieldsToShow = computed(() => {
      if (
        !isOffertypeLeasing.value &&
        (!leasingEnabled.value || noLeasingPermission.value)
      ) {
        return []
      }
      return fields.value
    })

    const onChange = async (state: boolean) => {
      if (state === false && fieldsHaveValues()) {
        confirm.show({
          variant: 'warning',
          title: 'Leasing',
          centered: true,
          text: t('form_values_deletion_confirm'),
          confirmButtonText: t('yes'),
          size: 'md',
          onConfirm: () => {
            leasingEnabled.value = false
            clearFieldset()
          }
        } as ConfirmationModalOptions)
        await nextTick()
        leasingEnabled.value = true
      }
    }

    const clearFieldset = () => {
      fields.value.forEach(f => {
        const fieldValue = getFieldValueByName(f.name)
        if (Array.isArray(fieldValue)) {
          commit(SET_FIELD_VALUE, { name: f.name, value: [] })
        } else if (isObject(fieldValue)) {
          const keys = Object.keys(fieldValue)
          const clearedValue = {}
          if (keys.length) {
            keys.forEach(k => {
              // clear depending on type (no recursion here)
              if (Array.isArray(fieldValue[k])) {
                clearedValue[k] = []
              } else if (isObject(fieldValue[k])) {
                clearedValue[k] = {}
              } else {
                clearedValue[k] = undefined
              }
            })
          }
          commit(SET_FIELD_VALUE, { name: f.name, value: clearedValue })
        } else {
          commit(SET_FIELD_VALUE, { name: f.name, value: undefined })
        }
      })
    }

    return {
      noLeasingPermission,
      fieldsToShow,
      t,
      leasingEnabled,
      onChange,
      isOffertypeLeasing
    }
  },
  i18n: defineComponentTranslations({
    do_you_offer_leasing: {
      en: 'Do you offer leasing?',
      el: 'Προσφέρεις leasing;'
    },
    leasing_fieldset_description: {
      en: 'Add leasing options to your classified',
      el: 'Πρόσθεσε επιλογές leasing στην αγγελία σου'
    },
    form_values_deletion_confirm: {
      en:
        'Are you sure you want to disable this option? any values will be deleted.',
      el:
        'Θέλεις σίγουρα να απενεργοποιήσεις αυτήν την επιλογή. Τυχόν τιμές που έχεις δηλώσει θα διαγραφούν.'
    }
  })
})
